var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-wrap m-wap"},[_c('Logo',{attrs:{"extras":_vm.extras}}),_c('Banner',{attrs:{"extras":_vm.extras}}),_c('SuccessCon',{attrs:{"extras":_vm.extras,"platform":_vm.platform,"is-show-again":_vm.isShowAgain}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }